goog.provide("shadow.js.shim.module$$mui$system");
goog.provide("module$shadow_js_shim_module$$mui$system");
shadow.js.shim.module$$mui$system = shadow.js.nativeProvides["@mui/system"] = shadow$bridge("@mui/system");
module$shadow_js_shim_module$$mui$system.default = shadow.js.shim.module$$mui$system;
